'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getStateKey = require('./get-state-key');

var _getStateKey2 = _interopRequireDefault(_getStateKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(state, elementKey, value) {
  var key = (0, _getStateKey2.default)(elementKey);

  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
};

exports.default = getState;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/radium/lib/get-state.js
 ** module id = 1329
 ** module chunks = 0
 **/